<app-loader [loading]="loading"></app-loader>
<form [formGroup]="form" (ngSubmit)="submit()" class="p-fluid">
    <div class="flex flex-col gap-1">
        <label for="name"><span class="text-red-500">*</span> Name</label>
        <app-verifiable-input group="create-user" field="name" class="w-full">
            <input pInputText id="name" formControlName="name" class="w-full" />
        </app-verifiable-input>
    </div>

    <div class="flex flex-wrap mt-3">
        <div class="flex flex-col col-6 pl-0 gap-1">
            <label for="email"> <span class="text-red-500">*</span> Email</label>
            <app-verifiable-input group="create-user" field="email" class="w-full">
                <input pInputText id="email" formControlName="email" class="w-full"/>
            </app-verifiable-input>
        </div>
        <div class="flex flex-col col-6 pr-0 gap-1">
            <label for="role"> <span class="text-red-500">*</span> Role</label>
            <app-verifiable-input group="create-user" field="role" class="w-full">
                <p-select id="role"
                          formControlName="role"
                          [options]="roleOptions"
                          placeholder="Select role"
                          appendTo="body"
                          class="w-full">
                </p-select>
            </app-verifiable-input>
        </div>
        <div class="flex flex-col col-6 pl-0 gap-1">
            <label for="phone">Phone</label>
            <input pInputText id="phone" formControlName="phone" [imask]="mask"/>
        </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
        <p-button type="button" label="Cancel" class="p-button-text" (click)="cancel()"></p-button>
        <p-button type="submit" label="Save"></p-button>
    </div>

</form>
<!--</p-blockUI>-->
